import "./OrderHistory.css";
export const OrderHistory = () => {
  return (
    <div className="order-history-container">
      <div className="order-header">
        <h1>No Order To Display</h1>
      </div>
    </div>
  );
};
